__webpack_require__.p = "/reports-remove-details-columns-max-width/account-setup/";